import React, { useState, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import publicProfileService from '../../services/publicProfileService';
import { usePlanPermissions } from '../../hooks/usePlanPermissions';
import './SharePublicProfileButton.css';

const SharePublicProfileButton = ({ talent }) => {
  const [copied, setCopied] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const { validateShareTalentProfile } = usePlanPermissions();
  const optionsRef = useRef(null);

  const slug = talent?.slug;

  // Fechar dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    if (showOptions) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showOptions]);

  const handleButtonClick = () => {
    setShowOptions(!showOptions);
  };

  const copyToClipboard = async (hours) => {
    setShowOptions(false);
    
    // Validar permissão antes de gerar o link
    const permissionCheck = validateShareTalentProfile();

    if (!permissionCheck.allowed) {
      return;
    }
    
    try {
      // Gerar token e obter URL do perfil público
      const result = await publicProfileService.generateToken(slug, hours);

      if (!result || !result.profileUrl) {
        throw new Error('Erro ao gerar link do perfil');
      }

      // Construir URL completa com o token
      const fullUrl = `${window.location.origin}${result.profileUrl}`;

      // Copiar para área de transferência
      await navigator.clipboard.writeText(fullUrl);

      setCopied(true);
      toast.success(`Link do perfil público copiado! Válido por ${hours}h`);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Erro ao gerar link do perfil:', err);

      const errorMessage = err?.message || 'Erro ao gerar o link do perfil';
      toast.error(errorMessage);
    }
  };

  return (
    <div className="share-public-profile-container" ref={optionsRef}>
      <div
        className={`share-public-profile-text ${copied ? 'copied' : ''}`}
        onClick={handleButtonClick}
        title={
          copied
            ? 'Link copiado!'
            : 'Compartilhar perfil público'
        }
        style={{
          cursor: 'pointer',
          opacity: 1
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          {copied ? (
            <polyline points="20 6 9 17 4 12"></polyline>
          ) : (
            <>
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
              <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
            </>
          )}
        </svg>
        {copied ? 'Copiado!' : 'Compartilhar perfil'}
      </div>

      {showOptions && !copied && (
        <div className="share-options-dropdown">
          <div className="share-options-title">Validade do link:</div>
          <button
            className="share-option-item"
            onClick={() => copyToClipboard(24)}
          >
            24 horas
          </button>
          <button
            className="share-option-item"
            onClick={() => copyToClipboard(48)}
          >
            48 horas
          </button>
          <button
            className="share-option-item"
            onClick={() => copyToClipboard(72)}
          >
            72 horas
          </button>
        </div>
      )}
    </div>
  );
};

export default SharePublicProfileButton;
